/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { gql } from '@apollo/client';

export const LIST_REQUESTS_BY_PROCEDURE = gql`
  query ListRequestsByProcedure(
    $procedureId: ID!
    $departmentId: ID!
    $limit: Int = 100
    $nextToken: String
    $state: RequestState
    $procedureStage: ProcedureStage
  ) {
    listRequestsByProcedure(
      procedureId: $procedureId
      departmentId: $departmentId
      limit: $limit
      nextToken: $nextToken
      state: $state
      procedureStage: $procedureStage
    ) {
      items {
        id
        stepPath
        contextId
        sentenceId
        createdAt
        handledAt
        state
        worker {
          id
          knowledgeId
        }
        uiConcepts
        questions {
          id
          text
          contextId
          sentenceId
          answerTypeHint
          ... on NativeCodeErrorQuestion {
            errorType
            errorMessage
            errorTraceback
          }
          ... on ReviewConceptQuestion {
            lexicalPath
            conceptId
          }
          ... on ValueNotKnownQuestion {
            lexicalPath
            choices
            helpText
            isPlural
          }
          ... on DomainNotIntegratedQuestion {
            domain
          }
          ... on MissingIntegrationCredentialQuestion {
            domain
          }
        }
        answers {
          id
          requestId
          questionId
          action {
            _
            ... on RetryStepAction {
              minimumDelay
              timeout
            }
            ... on UseConceptAction {
              conceptId
            }
            ... on UseLiteralValueAction {
              literalValue
            }
            ... on UseTechniqueAction {
              technique
            }
          }
          createdAt
          createdBy
        }
        contextPath {
          ctxId
          sentenceId
        }
      }
      limit
      nextToken
    }
  }
`;

export const GET_REQUEST = gql`
  query GetRequest($id: ID!) {
    getRequest(id: $id) {
      id
      stepPath
      contextId
      sentenceId
      createdAt
      handledAt
      state
      procedureId
      worker {
        id
        knowledgeId
      }
      uiConcepts
      questions {
        id
        text
        contextId
        sentenceId
        answerTypeHint
        ... on NativeCodeErrorQuestion {
          errorType
          errorMessage
          errorTraceback
        }
        ... on ReviewConceptQuestion {
          lexicalPath
          conceptId
        }
        ... on ValueNotKnownQuestion {
          lexicalPath
          choices
          helpText
          isPlural
        }
        ... on DomainNotIntegratedQuestion {
          domain
        }
        ... on MissingIntegrationCredentialQuestion {
          domain
        }
      }
      answers {
        id
        requestId
        questionId
        action {
          _
          ... on RetryStepAction {
            minimumDelay
            timeout
          }
          ... on UseConceptAction {
            conceptId
          }
          ... on UseLiteralValueAction {
            literalValue
          }
          ... on UseTechniqueAction {
            technique
          }
        }
        createdAt
        createdBy
      }
      contextPath {
        ctxId
        sentenceId
      }
    }
  }
`;

export const GET_REQUEST_ANSWER = gql`
  query GetRequestAnswer($id: ID!) {
    getRequestAnswer(id: $id) {
      id
      requestId
      questionId
      action {
        _
        ... on ReplaceStepAction {
          newSteps
        }
        ... on RetryStepAction {
          minimumDelay
          timeout
        }
        ... on UseConceptAction {
          conceptId
        }
        ... on UseLiteralValueAction {
          literalValue
          choices
        }
        ... on UseTechniqueAction {
          technique
        }
      }
      sourceLearning {
        id
      }
      derivedLearning {
        id
      }
      createdAt
      createdBy
      summary
    }
  }
`;
